// extracted by mini-css-extract-plugin
export default {"main":"Video_main__H4FT5","h1":"Video_h1__R4Ivk","span":"Video_span__BX2-1","h11":"Video_h11__DsXiU","img":"Video_img__I-kOI","h12":"Video_h12__IWd58"};